import {RootStore} from '../index';
import {action, makeAutoObservable} from "mobx"
import * as query from "query-string"
import ElementModel from "../../model/ElementModel";

export class ComTopSearchStore {

    search: string = '';
    rows: any[] = [];
    isFocus = false;
    categories = [];
    statusSearch: boolean = false;
    isEmptyResult: boolean = false;
    private inputTimer: NodeJS.Timeout | undefined;
    private currentSearchIndex: number = 0;
    private idForSearchArray: string[] = [];

    private rootStore: RootStore | undefined;

    constructor(rootStore?: RootStore) {
        makeAutoObservable(this);
        this.rootStore = rootStore;
    }

    init() {
        let urlOb = query.parse(window.location.search);
        if (urlOb.q !== undefined) {
            this.search = String(urlOb.q);
        }
        this.reload(true);
    }
    initByCategory() {
        let urlOb = query.parse(window.location.search);
        if (urlOb.q !== undefined) {
            this.search = String(urlOb.q);
        }
        this.reloadByCategory(true);
    }

    onChangeInput = (e: any) => {
        this.statusSearch = true
        this.search = e.target.value;
        if (this.inputTimer) {
            clearTimeout(this.inputTimer);
        }
        this.inputTimer = setTimeout(() => {
            this.reload();
        }, 300);
    }

    @action
    private resetSearchState = () => {
        this.isFocus = false;
        this.search = '';
        this.rows = [];
        this.categories = [];
    }

    onBlurInput = (e: any) => {
        setTimeout(() => {
            this.resetSearchState();
        }, 300)
    }

    onFocus = () => {
        this.isFocus = true;
    }


    reload(isCount = false) {
        
        // if(clientId === 0){
        //     // this.rootStore?.authStore.removeData()
        //     // this.rootStore?.authStore.init()
        //     this.rootStore?.mainStore.init()
        // }
        this.statusSearch = true
        let clientId = this.rootStore?.mainStore.getClientId() ?? 0;
      
        if(isCount){
            ElementModel.search(this.search, clientId, this.setData, this.setError)
            // ElementModel.searchLimit(this.search, clientId, this.setData, this.setError)
        }else{
            // ElementModel.searchLimit(this.search, clientId, this.setData, this.setError)
            ElementModel.search(this.search, clientId, this.setData, this.setError)
        }
    }
    reloadByCategory(isCount = false) {
        let clientId = this.rootStore?.mainStore.getClientId();
        ElementModel.searchByCategory(this.search, clientId, this.setData, this.setError)
        this.search = '';
        // if(isCount){
        //     ElementModel.searchLimit(this.search, clientId, this.setData, this.setError)
        // }else{
        //     ElementModel.search(this.search, clientId, this.setData, this.setError)
        // }
    }

    @action
    setData = (result: any) => {
        if(result.data.categories){
            this.categories = result.data.categories;
            console.log(this.categories)
        }else{
            this.categories = []
        }

        if(result.data.idForSearch){
            this.idForSearchArray = result.data.idForSearch;
            this.currentSearchIndex = 0;
            this.rows = []; // Clear existing rows before starting new search
            this.isEmptyResult = false; // Reset empty result state
            this.processNextSearch();
        } else {
            // If no idForSearch, check if rows exist
            if (result.data.rows && result.data.rows.length === 0) {
                this.isEmptyResult = true;
                this.rows = [];
            } else {
                this.isEmptyResult = false;
                this.rows = result.data.rows || [];
            }
        }

        this.statusSearch = false
    }

    private processNextSearch = () => {
        if (this.currentSearchIndex < this.idForSearchArray.length) {
            const currentId = this.idForSearchArray[this.currentSearchIndex];
            let clientId = this.rootStore?.mainStore.getClientId();
            ElementModel.searchTest(currentId, clientId, this.setDataTest, this.setError);
        } else {
            // All searches completed, check if we have any results
            if (this.rows.length === 0) {
                this.isEmptyResult = true;
            } else {
                this.isEmptyResult = false;
            }
        }
    }

    @action
    setDataTest = (result: any) => {
        if (result.data.rows) {
            // Используем более стабильный способ обновления массива
            // чтобы избежать подергивания при поэтапной загрузке
            const newRows = result.data.rows;
            if (newRows && newRows.length > 0) {
                this.rows = [...this.rows, ...newRows];
            }
        }
        
        // Move to next ID and process it
        this.currentSearchIndex++;
        this.processNextSearch();
    }

    @action
    clearSearch = () => {
        if ('/catalog/search' !== window.location.pathname) {
            this.search = ''
        }
    }

    @action
    setError = (error: any) => {
        this.statusSearch = false; // Reset loading state on error
        console.log(error);
        // this.error = error.response.data.message;
    }
}